import { baseThemeValues } from 'constants/common';

const labelSmBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

const componentBase = {
  borderRadius: '5px',
  borderWidth: '1px',
};

export const datePickerListTheme = {
  sm: {
    error: {
      ...componentBase,
      borderColor: 'palette.error.60',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelSmBase,
        text: 'palette.error.60',
      },
    },
    inactive: {
      ...componentBase,
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      icon: 'palette.tertiary.40',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
      modal: {
        bg: 'palette.tertiary.5',
        divider: 'palette.neutral.20',
      },
      placeholder: 'palette.tertiary.40',
    },
  },
};
